// Composable for opening the create DomainTerm dialog.
import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import { useDialog } from "primevue/usedialog";
import { defineAsyncComponent } from "vue";
import { computed, ref } from "vue";

import { useCurrentEntityManager } from "@/stores/entity-store";

import { useHotKeys } from "./hotkeys";

export const useEditDomainTermDialog = () => {
    const { domain } = useCurrentEntityManager();
    const dialog = useDialog();
    const dialogRef = ref<DynamicDialogInstance & { visible?: boolean }>();
    const isVisible = computed(() => Boolean(dialogRef.value?.visible));

    const registerHotKey = () => {
        const { addHotKey } = useHotKeys();

        addHotKey(
            "n t",
            (e) => {
                if (!isVisible.value && domain.value?.identity) {
                    e.preventDefault();
                    open();
                }
            },
            "Open new domain term dialog.",
            "Global"
        );
    };

    const open = () => {
        dialog.open(
            defineAsyncComponent(
                () => import("@/components/DomainTerms/NewDomainTerm.vue")
            ),
            {
                props: {
                    header: "Add term",
                    modal: true,
                    style: { width: "35rem" },
                },
            }
        );
    };

    return {
        open,
        isVisible,
        registerHotKey,
    };
};
